import { Grid } from "@mantine/core";
import { IconBuilding, IconLicense, IconUsers } from "@tabler/icons-react";
import StatsCard from "./StatsCard";

interface DashboardStats {
	totalAccounts: number;
	activeAccounts: number;
	activeLicenses: number;
	expiringLicenses: number;
	// null for roles that may not read user stats
	users: { total: number; admins: number; managers: number } | null;
}

interface StatsGridProps {
	stats: DashboardStats;
}

function StatsGrid({ stats }: StatsGridProps) {
	const dashboardCards = [
		{
			icon: IconBuilding,
			title: "Total Accounts",
			value: stats.totalAccounts.toString(),
			description: `${stats.activeAccounts} active`,
			color: "blue",
		},
		{
			icon: IconLicense,
			title: "Active Licenses",
			value: stats.activeLicenses.toString(),
			description: `${stats.expiringLicenses} expiring this week`,
			color: "green",
		},

		...(stats.users
			? [
					{
						icon: IconUsers,
						title: "Total Users",
						value: stats.users.total.toString(),
						description: `${stats.users.admins} admin, ${stats.users.managers} manager`,
						color: "violet",
					},
				]
			: []),
	];

	return (
		<Grid>
			{dashboardCards.map((stat, index) => (
				<Grid.Col
					key={index}
					span={{ base: 12, sm: 6, lg: 3 }}>
					<StatsCard {...stat} />
				</Grid.Col>
			))}
		</Grid>
	);
}

export default StatsGrid;
export type { DashboardStats };
